module.exports = __webpack_public_path__ + "static/media/s_v10_10.e8ab9274.mp3";